import React, { Suspense, lazy, useState } from "react";
import "./Hero.css";
import { useAnimation } from "../../hooks/useAnimation";
import "../../hooks/useAnimation.css";
import chantalVideo from "../../video/Video";
import { navigateTo } from "../../utils/navigateTo";
import { CALENDLY_URL } from "../../utils/links";

// Loaded on first use so the homepage doesn't carry the search code
const SiteSearchModal = lazy(() => import("../site-search/SiteSearchModal"));

const heroButtons = [
  { text: "Give", link: "/donate" },
  { text: "Schedule a one-on-one", link: CALENDLY_URL },

  { text: "New Believer", link: "/new-believer" },
  {
    text: "Submit a Testimony",
    link: "/testimony",
  },
  {
    text: "Prayer Requests",
    link: "/prayer",
  },
  { text: "Conferences", link: "/conferences" },
];

const Hero = () => {
  // The hero search opens the site-wide search modal; null when closed
  const [searchQuery, setSearchQuery] = useState<string | null>(null);

  // Staggered slide-in from right
  // title/desc animations removed as those elements are commented out
  const btnAnim = useAnimation({
    direction: "right",
    delay: 1700,
    duration: 1200,
  });

  return (
    <section className="hero-section">
      <video
        className="hero-bg-video"
        src={chantalVideo}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="hero-overlay" />
      <div className="hero-search">
        <input
          type="text"
          className="hero-search-input"
          placeholder="Search..."
          aria-label="Search the website"
          aria-haspopup="dialog"
          value=""
          onFocus={(e) => {
            e.currentTarget.blur();
            setSearchQuery("");
          }}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button className="hero-search-btn" aria-label="Search" onClick={() => setSearchQuery("")}>
          <svg
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </button>
      </div>
      <div className="hero-content">
        {/* <div className="hero-content-left">
          <h1
            className={`hero-title ${titleAnim.className}`}
            style={titleAnim.style}
          >
            {phrases[0].text}
          </h1>
          <p
            className={`hero-desc ${descAnim.className}`}
            style={descAnim.style}
          >
            {phrases[1].text}
          </p>
        </div> */}
        <div
          className={`hero-content-right ${btnAnim.className}`}
          style={btnAnim.style}
        >
          {heroButtons.map((btn, idx) => (
            <button
              className="hero-action-btn"
              key={idx}
              onClick={() => {
                if (btn.link.startsWith("http")) {
                  window.open(btn.link, "_blank", "noopener,noreferrer");
                } else {
                  navigateTo(btn.link);
                }
              }}
            >
              {btn.text}
            </button>
          ))}
        </div>
      </div>
      {searchQuery !== null && (
        <Suspense fallback={null}>
          <SiteSearchModal initialQuery={searchQuery} onClose={() => setSearchQuery(null)} />
        </Suspense>
      )}
    </section>
  );
};

export default Hero;
